<template>
  <transition name="fade">
    <div v-if="isLoading" class="global-spinner-overlay">
      <div class="spinner-container">
        <div class="preloader-wrapper big active">
          <div class="spinner-layer custom-spinner-color">
            <div class="circle-clipper left">
              <div class="circle"></div>
            </div><div class="gap-patch">
              <div class="circle"></div>
            </div><div class="circle-clipper right">
              <div class="circle"></div>
            </div>
          </div>
        </div>
        </div>
    </div>
  </transition>
</template>

<script>
import loadingStore from '@/store/loading' // Importa il nuovo store di caricamento

export default {
  name: 'GlobalSpinner',
  computed: {
    // Accedi al getter isLoading direttamente dallo store importato
    isLoading () {
      return loadingStore.getters.isLoading
    }
  }
}
</script>

<style scoped>
/* Overlay che copre l'intera pagina */
.global-spinner-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8); /* Sfondo semi-trasparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999999; /* Assicurati che sia sopra tutto il resto dell'UI */
}

/* Contenitore per lo spinner per centrarlo */
.spinner-container {
  /* Puoi aggiungere stili specifici per il tuo spinner qui */
}

/* Transizione di fade per un'apertura/chiusura più fluida */
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
.preloader-wrapper .spinner-layer.custom-spinner-color .circle-clipper .circle,
.preloader-wrapper .spinner-layer.custom-spinner-color .gap-patch .circle {
  border-color: #c42634; /* Esempio: Blu scuro. Cambia questo valore al tuo colore desiderato! */
  /* Puoi anche usare variabili CSS se le hai definite, es: var(--my-custom-blue); */
}
</style>
